const TermsOfService = () => {
  return (
    <div className="article">
      <div className="card card-style">
        <div className="content">
          <h1>Privacy Policy</h1>
          <br />
          <h2>1. Introduction</h2>
          This Privacy Policy governs the manner in which Appollow collects,
          uses, maintains and discloses information collected from users (each,
          a &quot;User&quot;) of the appollow.net website (&quot;Site&quot;).
          This privacy policy applies to the Site and all products and services
          offered by Appollow.
          <br />
          <br />
          <h2>2. Personal identification information</h2>
          We may collect personal identification information from Users in a
          variety of ways, including, but not limited to, when Users visit our
          site, register on the site, and in connection with other activities,
          services, features or resources we make available on our Site. Users
          may be asked for, as appropriate, name, email address, mailing
          address, phone number. Users may, however, visit our Site anonymously.
          We will collect personal identification information from Users only if
          they voluntarily submit such information to us. Users can always
          refuse to supply personally identification information, except that it
          may prevent them from engaging in certain Site related activities.
          <br />
          <br />
          <h2>3. Non-personal identification information</h2>
          We may collect non-personal identification information about Users
          whenever they interact with our Site. Non-personal identification
          information may include the browser name, the type of computer and
          technical information about Users means of connection to our Site,
          such as the operating system and the Internet service providers
          utilized and other similar information.
          <br />
          <br />
          <h2>4. Web browser cookies</h2>
          Our Site may use &quot;cookies&quot; to enhance User experience.
          User&apos;s web browser places cookies on their hard drive for
          record-keeping purposes and sometimes to track information about them.
          User may choose to set their web browser to refuse cookies, or to
          alert you when cookies are being sent. If they do so, note that some
          parts of the Site may not function properly.
          <br />
          <br />
          <h2>5. How we use collected information</h2>
          Appollow may collect and use Users personal information for the
          following purposes:
          <ol>
            <li>
              To improve customer service Information you provide helps us
              respond to your customer service requests and support needs more
              efficiently.
            </li>
            <li>
              To personalize user experience We may use information in the
              aggregate to understand how our Users as a group use the services
              and resources provided on our Site.
            </li>

            <li>
              To improve our Site We may use feedback you provide to improve our
              products and services.
            </li>
            <li>
              To send periodic emails We may use the email address to send User
              information and updates pertaining to their order. It may also be
              used to respond to their inquiries, questions, and/or other
              requests. If User decides to opt-in to our mailing list, they will
              receive emails that may include company news, updates, related
              product or service information, etc. If at any time the User would
              like to unsubscribe from receiving future emails, we include
              detailed unsubscribe instructions at the bottom of each email.
            </li>
          </ol>
          <br />
          <h2>6. How we protect your information</h2>
          We adopt appropriate data collection, storage and processing practices
          and security measures to protect against unauthorized access,
          alteration, disclosure or destruction of your personal information,
          username, password, transaction information and data stored on our
          Site.
          <br />
          <br />
          <h2>7. Sharing your personal information</h2>
          We do not sell, trade, or rent Users personal identification
          information to others. We may share generic aggregated demographic
          information not linked to any personal identification information
          regarding visitors and users with our business partners, trusted
          affiliates and advertisers for the purposes outlined above.
          <br />
          <br />
          <h2>8. Third-party websites</h2>
          Users may find advertising or other content on our Site that link to
          the sites and services of our partners, suppliers, advertisers,
          sponsors, licensors and other third parties. We do not control the
          content or links that appear on these sites and are not responsible
          for the practices employed by websites linked to or from our Site. In
          addition, these sites or services, including their content and links,
          may be constantly changing. These sites and services may have their
          own privacy policies and terms of use, which you should review before
          using them. We do not endorse or make any representations about any
          third-party websites or services. Your use of such websites and
          services is at your own risk. Also, Our Privacy Policy only applies to
          information that we collect on our Site, and we are not responsible
          for the privacy practices or content of third-party websites or
          services that you may access through links on our Site. We encourage
          you to read the privacy policies of any third-party websites or
          services that you visit.
        </div>
      </div>
    </div>
  )
}

export default TermsOfService
